module.exports = __webpack_public_path__ + "static/media/yt-mall-ride.753e84b9.mov";